module.exports = __webpack_public_path__ + "static/media/google_play_btn.5ffef2d7.png";